module.exports = require("findup-sync");


//////////////////
// WEBPACK FOOTER
// external "findup-sync"
// module id = 119
// module chunks = 0 1